import angular from 'angular';

import { excludeKeysFilter } from './exclude-keys.filter/exclude-keys';
import { keysInObjFilter } from './keys-in-obj.filter/keys-in-obj';
import { opentypeFeatureCSSFilter } from './opentype-feature-css.filter/opentype-feature-css';
import { FilterService } from './service.tn.filters';

export default angular
    .module('tn.utils', [])
    .filter('excludeKeys', excludeKeysFilter)
    .filter('keysInObj', keysInObjFilter)
    .filter('opentypeFeatureCSS', opentypeFeatureCSSFilter)
    .factory('tn.utils.service.filter', FilterService).name;
